import { useEffect, useState } from "react";
import useMediaQuery from './hooks/useMediaQuery';
import { DotGroup } from "./scenes/DotGroup";
import { Landing } from "./scenes/Landing";
import MySkills from "./scenes/MySkills";
import { motion } from "framer-motion";
import Projects from "./components/Projects";
import LineGradient from "./components/LineGradient";
import Navbar from "./scenes/Navbar";
import { Contact } from "./components/Contact";
import Footer from "./components/Footer";
import Parallax from "./components/parallax/Parallax";

function App() {
  const [selectedPage, setSelectedPage] = useState('home');
  const isDesktop = useMediaQuery("(min-width: 1060px)");
  const [isTopOfPage, setIsTopOfPage] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("home");
      } else {
        setIsTopOfPage(false);
      }

      // Check which section is in view
      const sections = document.querySelectorAll('section');
      let currentSection = 'home';

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (window.scrollY >= sectionTop - sectionHeight / 3) {
          currentSection = section.getAttribute('id');
        }
      });

      setSelectedPage(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app bg-deep-blue">
      <Navbar
        isTopOfPage={isTopOfPage}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
      />
      <div className="w-5/6 mx-auto md:h-full">
        <motion.div
          margin="0 0 -200px 0"
          amount="all"
          onViewportEnter={() => setSelectedPage("home")}
        >
          <section id="home">
            <Landing setSelectedPage={setSelectedPage} />
          </section>
        </motion.div>
      </div>
      <div className="w-5/6 md:h-full">
      {isDesktop && (
          <DotGroup
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
        )}
        <motion.div
          margin="0 0 -200px 0"
          amount="some"
          onViewportEnter={() => setSelectedPage("skills")}
        >
          <section id="skills">
            <Parallax />
            {/* <MySkills /> */}
          </section>
        </motion.div>
      </div>
      {/* <LineGradient /> */}
      <div className="w-5/6 mx-auto">
        <motion.div
          margin="0 0 -200px 0"
          amount="some"
          onViewportEnter={() => setSelectedPage("projects")}
        >
          <section id="projects">
            <Projects />
          </section>
        </motion.div>
      </div>
      <div className="w-5/6 mx-auto md:h-full">
        <motion.div
          margin="0 0 -200px 0"
          amount="some"
          onViewportEnter={() => setSelectedPage("contact")}
        >
          <section id="contact">
            <Contact />
          </section>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
